<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header align-items-center">
      <h2>Kursy</h2>
      <b-button class="ml-3" variant="primary" @click="onAdd">
        <font-awesome-icon icon="plus" size="xs"></font-awesome-icon>&nbsp; Utwórz
      </b-button>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <b-col cols="12">
        <filters-panel class="ml-3" @filters-search="onSearch"></filters-panel>
      </b-col>
      <b-col cols="12">
        <data-table
          class="m-2"
          ref="table"
          :dtFields="fields"
          :dtFieldsKey="primaryKey"
          :dtPageSizes="pageSizes"
          :dtPageSize="pageSize"
          :dtPage="currentPage"
          :dtItemsProvider="getData"
          :dtItemsTotal="total"
          @onDetails="onDetails"
          @onEdit="onEdit"
          @onDelete="onDelete"
        ></data-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { axios, eventBus } from "@/_infrastructure";

import DataTable from "@/components/DataTable.vue";
import FiltersPanel from "./components/ListFiltersPanel.vue";

const fields = [
  { key: "index", sortable: false, label: "#" },
  { key: "name", sortable: true, label: "Nazwa" },
  {
    key: "languageProficiency",
    sortable: true,
    label: "Poziom zaawansowania",
    formatter: value => {
      if (value == "0") return "Beginner";
      if (value == "1") return "Elementary";
      if (value == "2") return "Intermediate";
      if (value == "3") return "Upper-Intermediate";
      if (value == "4") return "Advanced";
      if (value == "5") return "Proficient";
      if (value == "6") return "Pre-Intermediate";
      else return "";
    }
  },
  { key: "description", sortable: true, label: "Opis" },
  { key: "details", sortable: false, label: "", tdClass: "b-table-action" },
  { key: "edit", sortable: false, label: "", tdClass: "b-table-action" },
  { key: "delete", sortable: false, label: "", tdClass: "b-table-action" }
];

const primaryKey = "id";

export default {
  components: { FiltersPanel, DataTable },
  data() {
    return {
      filters: null,
      pageSizes: [10, 20, 30, 50],
      pageSize: 10,
      currentPage: 1,
      fields: fields,
      primaryKey: primaryKey,
      isLoading: true,
      total: 0
    };
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    onDetails(rowId) {
      this.goto({ path: `/site/courses/details/${rowId}` });
    },
    onAdd() {
      this.goto({ path: "/site/courses/add" });
    },
    onEdit(rowId) {
      this.goto({ path: `/site/courses/edit/${rowId}` });
    },
    onDelete(rowId) {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz usunąć wskazany szablon kursu?")
        .then(value => {
          if (value) {
            this.onSubmitDelete(rowId);
          }
        });
    },
    onSubmitDelete(rowId) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      axios
        .delete("/templatecourses", {
          params: {
            id: rowId
          }
        })
        .then(() => {
          eventBus.$emit("notify-success", "Poprawnie usunięto szablon kursu.");
          this.$refs.table.refresh();
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    onSearch(filters) {
      this.filters = filters;
      this.$refs.table.refresh();
    },
    getData(ctx) {
      var self = this;
      var queryObject = { ...ctx, ...this.filters }; //FiltersPanel.queryObject(ctx);

      return axios
        .get("templatecourses", { params: queryObject })
        .then(result => {
          self.total = result.data.total;
          return result.data.rows;
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
          return null;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>
